import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { SupportCaseStatus } from '../../models/SupportCase';
import { supportCaseStatusLabel } from '../../utils/supportCases';

interface SupportCaseStatusChipProps {
  status: SupportCaseStatus;
  size?: 'small' | 'medium';
}

const STATUS_SX: Record<
  SupportCaseStatus,
  { color: string; bgcolor: string; borderColor: string }
> = {
  OPEN: {
    color: '#93c5fd',
    bgcolor: 'rgba(59, 130, 246, 0.18)',
    borderColor: 'rgba(59, 130, 246, 0.45)',
  },
  RESOLVED: {
    color: '#86efac',
    bgcolor: 'rgba(34, 197, 94, 0.16)',
    borderColor: 'rgba(34, 197, 94, 0.4)',
  },
  CLOSED: {
    color: 'rgba(255,255,255,0.72)',
    bgcolor: 'rgba(255,255,255,0.08)',
    borderColor: 'rgba(255,255,255,0.2)',
  },
};

const SupportCaseStatusChip: React.FC<SupportCaseStatusChipProps> = ({
  status,
  size = 'small',
}) => {
  const { t } = useTranslation();
  const palette = STATUS_SX[status] ?? STATUS_SX.CLOSED;

  return (
    <Chip
      size={size}
      label={supportCaseStatusLabel(status, t)}
      sx={{
        height: size === 'small' ? 22 : 28,
        fontWeight: 700,
        fontSize: size === 'small' ? '0.7rem' : '0.75rem',
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
        border: 1,
        borderColor: palette.borderColor,
        color: palette.color,
        bgcolor: palette.bgcolor,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
};

export default SupportCaseStatusChip;
